/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import PropTypes from "prop-types"
import GoogleMapReact from "google-map-react"

// preliminary Google key, should be removed for production mode
const apiKey = "AIzaSyDircXqv3fMxN7Q-iHaAkZ2JIETt2NG9h0"

const Wrapper = ({ children, width }) => (
  <main sx={{ width: width, height: [width, 1.3 * width, 0.75 * width] }}>{children}</main>
)

const GoogleMap = ({ children, mapWidth, center: [lat, lng], ...props }) => {
  const api = process.env.GOOGLE_KEY || apiKey
  return (
    <Wrapper width={`${mapWidth}px`}>
      {lat && lng && (
        <GoogleMapReact
          bootstrapURLKeys={{ key: api }}
          center={[lat, lng]}
          {...props}
          sx={{
            width: `${mapWidth}px !important`,
            height: [mapWidth, 1.3 * mapWidth, 0.75 * mapWidth],
          }}
        >
          {children}
        </GoogleMapReact>
      )}
    </Wrapper>
  )
}

GoogleMap.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
}

GoogleMap.defaultProps = {
  children: null,
}

export default GoogleMap
